import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { SettingsResponse, UpdateSettingsRequest } from '@/api/types';

export function useSettings(locationId?: string) {
  const params = locationId ? `?locationId=${locationId}` : '';
  return useQuery({
    queryKey: ['adminSettings', locationId ?? 'tenant'],
    queryFn: () => apiClient<SettingsResponse>(`/admin/settings${params}`),
  });
}

export function useUpdateSettings(locationId?: string) {
  const qc = useQueryClient();
  const params = locationId ? `?locationId=${locationId}` : '';
  return useMutation({
    mutationFn: (request: UpdateSettingsRequest) =>
      apiClient<SettingsResponse>(`/admin/settings${params}`, {
        method: 'PUT',
        body: JSON.stringify(request),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['adminSettings'] });
    },
  });
}
